export const resolveAttribute = (item: any, attribute: string) => {
  // Try all the possible places the attribute could be.
  return item[attribute] || item.data?.[attribute] || item.meta?.[attribute];
};
